import { IDottedDate } from '@SiteComponents/DottedDateInput'

const isValidDottedDate = (date: IDottedDate): { valid: boolean } => {
  const day = Number(date.day)
  const month = Number(date.month)
  const year = Number(date.year)

  if (!day || !month || !year) { return { valid: false } }
  if (day < 1 || day > 31) { return { valid: false } }
  if (month < 1 || month > 12) { return { valid: false } }
  if (year < 1000 || year > 9999) { return { valid: false } }

  return { valid: true }
}

export default isValidDottedDate
